import React, {useState} from 'react'
import '../App.css'

function InputField({label, id, isDisabled, value}) {
  const [val,setVal] = useState(value)
  console.log('val',val)
  
  return (
    <div className='input-field-container'>
      <label htmlFor={id} className='label'>{label}</label>
      <input 
        type='number' 
        id={id}
        className='input-field' 
        disabled={isDisabled}
        value={val}
        onChange={e => setVal(e.target.value)}
      />
    </div>
  )
}

InputField.defaultProps = {
  value:0
}
export default InputField
